<div class="btn-group">
    <ng-container *ngFor="let btn of btns">
        <ui-btn [btn]="btn" (click)="emit(btn.id || '')"></ui-btn>
    </ng-container>
</div>